import React from 'react';
import SignInEmail from './SignInEmail';
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    paper: {
        marginTop: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        marginBottom: theme.spacing(0),
    },
    sectionTitle: {
        marginTop: theme.spacing(0),
    }
}));

const SignIn = props => {
    const classes = useStyles();

    return (
        <div className={classes.paper}>
            <Typography component="h6" variant="h6" className={classes.sectionTitle}>
                Sign in with your Email
            </Typography>
            <SignInEmail/>
        </div>
    );
};

export default SignIn;
